import { Fragment, Suspense, lazy, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import "components/Institutional/institutional.css";
import Presentation from "layouts/pages/presentation";
import Formularios from "pages/Formularios";
import FormulariosV2 from "pages/FormulariosV2";
import SolicitudInscripcionV2 from "pages/FormulariosV2/SolicitudInscripcionV2";
import AnexoInscripcionV2 from "pages/FormulariosV2/AnexoInscripcionV2";
import routes from "routes";
const FormulariosV3 = lazy(() => import("pages/FormulariosV3"));
const DocumentacionCompleta = lazy(() => import("pages/Formularios/DocumentacionCompleta"));
const EnrollmentV3 = lazy(() =>
  import("pages/FormulariosV3").then((module) => ({ default: module.EnrollmentV3 }))
);

export default function App() {
  const { pathname } = useLocation();
  const isEnrollment = /^\/formularios(?:-v[23])?(?:\/|$)/i.test(pathname);
  const SiteWrapper = isEnrollment ? Fragment : "div";

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SiteWrapper {...(isEnrollment ? {} : { className: "institutional-site", lang: "es" })}>
        <Suspense fallback={<p role="status">Cargando formularios…</p>}>
          <Routes>
            {getRoutes(routes)}
            <Route path="/formularios" element={<Formularios />} />
            <Route path="/formularios-v3" element={<FormulariosV3 />} />
            <Route
              path="/formularios-v3/solicitud-inscripcion"
              element={<EnrollmentV3 documentType="solicitud" />}
            />
            <Route
              path="/formularios-v3/anexo-inscripcion"
              element={<EnrollmentV3 documentType="anexo" />}
            />
            <Route
              path="/formularios/solicitud-inscripcion-v3"
              element={<EnrollmentV3 documentType="solicitud" />}
            />
            <Route
              path="/formularios/anexo-inscripcion-v3"
              element={<EnrollmentV3 documentType="anexo" />}
            />
            <Route
              path="/formularios/solicitud-inscripcion"
              element={<DocumentacionCompleta />}
            />
            <Route
              path="/formularios/anexo-inscripcion"
              element={<DocumentacionCompleta />}
            />
            <Route path="/formularios/documentacion-completa" element={<DocumentacionCompleta />} />
            <Route path="/formularios-v2" element={<FormulariosV2 />} />
            <Route
              path="/formularios-v2/solicitud-inscripcion"
              element={<SolicitudInscripcionV2 />}
            />
            <Route path="/formularios-v2/anexo-inscripcion" element={<AnexoInscripcionV2 />} />
            <Route
              path="/formularios/solicitud-inscripcion-v2"
              element={<SolicitudInscripcionV2 />}
            />
            <Route path="/formularios/anexo-inscripcion-v2" element={<AnexoInscripcionV2 />} />
            <Route path="/" element={<Presentation />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
      </SiteWrapper>
    </ThemeProvider>
  );
}
